import { Box, TextField } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import { passwordMessages } from "../../constants";
import regex from "../../utils/regex";
import {
  BackToLoginLink,
  StepHeader,
  StepMessage,
  submitButtonSx,
} from "../../components/Auth/common";

export default function NewPasswordStep({
  newPassword,
  confirmPassword,
  onNewPasswordChange,
  onConfirmPasswordChange,
  onSubmit,
  isSubmitting,
  error,
}) {
  // Errors show only once a field has a value, so the empty form isn't all red
  const isPasswordInvalid = Boolean(newPassword) && !regex.password.test(newPassword);
  const isMismatch = Boolean(confirmPassword) && confirmPassword !== newPassword;
  const canSubmit = Boolean(newPassword) && !isPasswordInvalid && confirmPassword === newPassword;

  function handleSubmit(event) {
    event.preventDefault();
    if (canSubmit) onSubmit();
  }

  return (
    <Box component="form" noValidate onSubmit={handleSubmit}>
      <StepHeader title="Reset your password">
        Choose a new password for your account.
      </StepHeader>

      <TextField
        fullWidth
        type="password"
        name="newPassword"
        label="New password"
        autoComplete="new-password"
        autoFocus
        value={newPassword}
        onChange={(event) => onNewPasswordChange(event.target.value)}
        error={isPasswordInvalid}
        helperText={isPasswordInvalid && passwordMessages.RULES}
        inputProps={{ maxLength: 32 }}
        margin="dense"
      />

      <TextField
        fullWidth
        type="password"
        name="confirmPassword"
        label="Confirm new password"
        autoComplete="new-password"
        value={confirmPassword}
        onChange={(event) => onConfirmPasswordChange(event.target.value)}
        error={isMismatch}
        helperText={isMismatch && passwordMessages.MISMATCH}
        inputProps={{ maxLength: 32 }}
        margin="dense"
      />

      <StepMessage error={error} />

      <LoadingButton
        fullWidth
        type="submit"
        variant="contained"
        loading={isSubmitting}
        disabled={!canSubmit}
        sx={{ ...submitButtonSx, mb: 3 }}
      >
        Reset password
      </LoadingButton>

      <BackToLoginLink />
    </Box>
  );
}
